"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/starts-with"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _axios = _interopRequireDefault(require("axios"));

var _axiosRetry = _interopRequireDefault(require("axios-retry"));

var _arg = _interopRequireDefault(require("@spothero/arg"));

var _storage = _interopRequireDefault(require("../storage/storage"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; (0, _forEach.default)(_context2 = ownKeys(source, true)).call(_context2, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context3; (0, _forEach.default)(_context3 = ownKeys(source)).call(_context3, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var clientFingerprintName = 'sh-client-fingerprint';

var firewallRetryCondition = function firewallRetryCondition(error) {
  return !(0, _isNil.default)(error.response) && error.response.status === 456;
};

var buildConfig = function buildConfig(_ref) {
  var baseUrl = _ref.baseUrl,
      additionalHeaders = _ref.additionalHeaders,
      _ref$xsrfCookieName = _ref.xsrfCookieName,
      xsrfCookieName = _ref$xsrfCookieName === void 0 ? 'csrftoken' : _ref$xsrfCookieName,
      _ref$xsrfHeaderName = _ref.xsrfHeaderName,
      xsrfHeaderName = _ref$xsrfHeaderName === void 0 ? 'X-CSRFToken' : _ref$xsrfHeaderName,
      args = (0, _objectWithoutProperties2.default)(_ref, ["baseUrl", "additionalHeaders", "xsrfCookieName", "xsrfHeaderName"]);

  var clientFingerprint = _storage.default.get(clientFingerprintName, 'cookie');

  var config = _objectSpread({
    baseURL: baseUrl,
    headers: _objectSpread({
      'X-Requested-With': 'XMLHttpRequest'
    }, additionalHeaders),
    validateStatus: function validateStatus(status) {
      return status < 500 && status !== 456;
    },
    xsrfCookieName: xsrfCookieName,
    xsrfHeaderName: xsrfHeaderName
  }, args);

  if (!(0, _isNil.default)(clientFingerprint)) {
    config.headers[clientFingerprintName] = clientFingerprint;
  }

  return config;
};
/**
 * Utilities for working with APIs.
 * @module APIUtils
 */


var AxiosInstance =
/*#__PURE__*/
function () {
  function AxiosInstance(_config) {
    var _this = this;

    (0, _classCallCheck2.default)(this, AxiosInstance);
    (0, _defineProperty3.default)(this, "init", function (config) {
      _this._axiosInstance = _axios.default.create(buildConfig(config));

      _this.attachInterceptor({
        method: 'request',
        fulfilled: function fulfilled(currentConfig) {
          var _context;

          if ((0, _startsWith.default)(_context = currentConfig.baseURL.toLowerCase()).call(_context, 'http')) {
            // Non-relative call, remove the fingerprint to avoid possible CORS issues.
            delete currentConfig.headers[clientFingerprintName];
          }

          return currentConfig;
        },
        rejected: function rejected(error) {
          return _promise.default.reject(error);
        }
      });

      _this.attachInterceptor({
        method: 'response',
        fulfilled: function fulfilled(response) {
          if (response.status >= 400 && response.status < 500) {
            return _promise.default.reject(response);
          } else {
            return response;
          }
        },
        rejected: function rejected(error) {
          return _promise.default.reject(error);
        }
      });

      return _this._axiosInstance;
    });
    (0, _defineProperty3.default)(this, "attachInterceptor", function (_ref2) {
      var method = _ref2.method,
          fulfilled = _ref2.fulfilled,
          rejected = _ref2.rejected;

      _this._axiosInstance.interceptors[method].use(fulfilled, rejected);
    });
    (0, _defineProperty3.default)(this, "get", function (path, data, config) {
      return _this._axiosInstance.get(path, _objectSpread({
        params: data
      }, config));
    });
    (0, _defineProperty3.default)(this, "post", function (path, data, config) {
      var stringify = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var headers = config && config.headers ? config.headers : null;
      var formattedData = stringify ? _arg.default.stringify(data) : data;
      return _this._axiosInstance.post(path, formattedData, _objectSpread({}, config, {
        headers: _objectSpread({}, headers, {
          'X-CSRFToken': _storage.default.get('csrftoken', 'cookie')
        })
      }));
    });
    (0, _defineProperty3.default)(this, "patch", function (path, data, config) {
      return _this._axiosInstance.patch(path, data, config);
    });
    (0, _defineProperty3.default)(this, "delete", function (path, config) {
      return _this._axiosInstance.delete(path, config);
    });
    (0, _defineProperty3.default)(this, "all", function (requests) {
      return _axios.default.all(requests);
    });
    (0, _defineProperty3.default)(this, "spread", function (callback) {
      return _axios.default.spread(callback);
    });
    (0, _defineProperty3.default)(this, "addRetry", function (_ref3) {
      var _ref3$retries = _ref3.retries,
          retries = _ref3$retries === void 0 ? 3 : _ref3$retries,
          _ref3$retryDelay = _ref3.retryDelay,
          retryDelay = _ref3$retryDelay === void 0 ? _axiosRetry.default.exponentialDelay : _ref3$retryDelay,
          _ref3$retryCondition = _ref3.retryCondition,
          retryCondition = _ref3$retryCondition === void 0 ? firewallRetryCondition : _ref3$retryCondition,
          args = (0, _objectWithoutProperties2.default)(_ref3, ["retries", "retryDelay", "retryCondition"]);
      (0, _axiosRetry.default)(_this._axiosInstance, _objectSpread({
        retries: retries,
        retryDelay: retryDelay,
        retryCondition: retryCondition
      }, args));
    });
    this._axiosInstance = null;

    if (!(0, _isNil.default)(_config)) {
      this._axiosInstance = this.init(_config);
    }

    return this;
  }
  /**
   * Creates a default instance of APIUtils.
   * @static
   * @function init
   * @param {Object} config - The configuration object.
   * @param {String} config.baseUrl - The base URL for all API requests in this instance.
   * @param {Object} [config.additionalHeaders] - Additional headers to add to every request.
   * @param {String} [config.xsrfCookieName='csrftoken'] - The name of the cookie to use as a value for the XSRF token.
   * @param {String} [config.xsrfHeaderName='X-CSRFToken'] - The name of the HTTP header that carries the XSRF token value.
   * @example
   * const serviceInstance = APIUtils.init({
   *     baseUrl: 'api/v1',
   *     additionalHeaders: {
   *         UserAgent: 'header-name'
   *     }
   * });
   * @returns {Object} - The axios instance.
   */


  (0, _createClass2.default)(AxiosInstance, [{
    key: "makeCancelable",

    /**
     * Creates a cancelable promise.
     * @static
     * @function makeCancelable
     * @param {Promise} promise - The promise to make cancelable.
     * @example
     * const dataLoader = APIUtils.makeCancelable(
     *     APIUtils.get('api/v1/test')
     * );
     *
     * dataLoader.cancel();
     * @returns {Object} - An object containing the `promise` as well as the `cancel` method.
     */
    value: function makeCancelable(promise) {
      var hasCanceled = false;
      var wrappedPromise = new _promise.default(function (resolve, reject) {
        promise.then(function (val) {
          if (hasCanceled) {
            reject({
              isCanceled: true
            }); // eslint-disable-line prefer-promise-reject-errors
          } else {
            resolve(val);
          }
        }).catch(function (error) {
          if (hasCanceled) {
            reject({
              isCanceled: true
            }); // eslint-disable-line prefer-promise-reject-errors
          } else {
            reject(error);
          }
        });
      });
      return {
        promise: wrappedPromise,
        cancel: function cancel() {
          hasCanceled = true;
        }
      };
    }
    /**
     * Attaches an interceptor of the specified method to the axios instance.
     * @static
     * @function attachInterceptor
     * @param {Object} [data={}] - The interceptor data.
     * @param {String} [data.method=null] - The type of method to attach the interceptor to ('request' or 'response').
     * @param {Function} [data.fulfilled=null] - The function to handle `then` for a `Promise`.
     * @param {Function} [data.rejected=null] - The function to handle `reject` for a `Promise`.
     * @example
     * APIUtils.attachInterceptor({
     *     method: 'request',
     *     fulfilled: config => {
     *         ...code here
     *
     *         return config;
     *     },
     *     rejected: error => {
     *         return Promise.reject(error);
     *     }
     * });
     * @returns {void}
     */

  }]);
  return AxiosInstance;
}();

var _default = AxiosInstance;
exports.default = _default;